import { Tooltip } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import React, { useState, useRef, useEffect, useCallback } from 'react';
import EventLabel from '../../components/EventLabel/EventLabel';
import SystemLabel from '../../components/Systemlabel/SystemLabel';
import { twMerge } from 'tailwind-merge';

interface ISubmitButtonProps {
  register: (callback: () => void) => void;
  environment: any;
  settings: any;
  triggerValidation: () => void;
  getFilteredValidations: () => any;
  mainEventFullbooked: boolean;
  grpRegDisabled?: boolean;
  groupRegValidationMessage?: {
    label: string;
    value: string | number;
  } | null;
  validate: boolean;
}

export const SubmitButton = observer((props: ISubmitButtonProps) => {
  const registerCallbackRef = useRef<() => void>(() => null);
  const [disableButton, setDisableButton] = useState<boolean>(false);

  const {
    register,
    environment,
    settings,
    triggerValidation,
    getFilteredValidations,
    mainEventFullbooked,
    groupRegValidationMessage,
    grpRegDisabled = false,
    validate,
  } = props;

  const { texts } = settings;

  const registerCallback = () => setDisableButton(false);

  useEffect(() => {
    registerCallbackRef.current = registerCallback;
  });

  useEffect(() => {
    if (mainEventFullbooked && !disableButton) {
      setDisableButton(props.mainEventFullbooked && !disableButton);
    }
  }, [props?.mainEventFullbooked]);

  const handleSubmit = useCallback(() => {
    const isValid = getFilteredValidations()?.length === 0;
    if (isValid && !grpRegDisabled) {
      register(() => registerCallbackRef.current());
      setDisableButton(true);
    } else {
      triggerValidation();
    }
  }, [register, triggerValidation, getFilteredValidations, grpRegDisabled]);

  return (
    <div className="flex flex-col items-center">
      <Tooltip title={<EventLabel name="GroupRegMinCountValidationMessage" groupName="CMS.GROUPMODULE" textOnly />} disableHoverListener={!grpRegDisabled}>
        <button className={twMerge('cms-button', groupRegValidationMessage && validate ? 'w-min' : '')} disabled={disableButton} onClick={handleSubmit}>
          {texts ? texts[environment.lang] : settings.register[environment.lang]}
        </button>
      </Tooltip>
      {groupRegValidationMessage && validate && (
        <span className="text-red-500 flex mt-2">
          <SystemLabel name={groupRegValidationMessage?.label} groupName="CMS.GROUPMODULE" />
          {': '}
          {groupRegValidationMessage?.value}
        </span>
      )}
    </div>
  );
});
